import { TooltipDirective } from '../../../../auxiliares/tooltip/tooltip.directive';
import { BOTONES } from '../../../../componentes/botones';
import {
  Component,
  Input,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { ILogHttp } from 'modelos/src';
import { JsonTreeComponent } from '../json-tree/json-tree.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-detalles-request-http',
  templateUrl: './detalles-request-http.component.html',
  styleUrl: './detalles-request-http.component.scss',
  standalone: true,
  imports: [TooltipDirective, JsonTreeComponent, BOTONES, MatIconModule],
})
export class DetallesRequestHttpComponent implements OnChanges {
  @Input() title: string;
  @Input() data: ILogHttp;
  @Output() close = new EventEmitter<void>();

  ngOnChanges(): void {
    if (this.data) {
      // Sobrescribe los campos como objetos
      this.data = {
        ...this.data,
        headers: this.parseJsonField(this.data.headers),
        query: this.parseJsonField(this.data.query),
        params: this.parseJsonField(this.data.params),
        body: this.parseJsonField(this.data.body),
      };
    }
  }

  parseJsonField(value: string | undefined): any {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (e) {
      console.warn('No se pudo parsear JSON:', value);
      return value;
    }
  }

  isObject(val: any): boolean {
    return val && typeof val === 'object' && !Array.isArray(val);
  }

  isArray(val: any): boolean {
    return Array.isArray(val);
  }

  onClose(): void {
    this.close.emit();
  }
}
